import src from "IMAGE";
export default { src, width: 301, height: 75, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFoTJVUiBw4fRQ8cQzwNGTkkDRMhLy0uKUJCQjsiIiIcAJAfO4puGC1pehoyeWYWKmFuKjtoYl1eWnh4eG5oaGhdqHwQGtpsG4wAAAAASUVORK5CYII="};
